import React, { useRef } from 'react'
import { HorizontalStack, Icon, ShowIf } from '@ztechapps/webui.util'
import type { HeaderCellProps } from './types'
import merge from 'lodash/merge'
import { useTableContext } from '../Context'
import { LinkHeaderCell } from './LinkHeaderCell'
import { PopoverTableConfig } from '../table-config/PopoverTableConfig'

export type MenuHeaderCellProps = Omit<HeaderCellProps, 'children'>

export const MenuHeaderCell = ({ style, className = 'text-center', ...rest }: MenuHeaderCellProps) => {
  const {
    listResult: { loading },
    setShowConfig,
    hasActiveFilter,
  } = useTableContext()

  const target = useRef<HTMLTableCellElement>(null)
  style = merge({}, { width: '10px' }, style)

  return (
    <>
      <LinkHeaderCell
        style={style}
        className={className}
        ref={target}
        onClick={() => setShowConfig((current) => !current)}
        disabled={loading}
        {...rest}
      >
        <HorizontalStack gap={1}>
          <Icon name={'sliders'} />
          <ShowIf condition={hasActiveFilter()}>
            <Icon name={'filter'} />
          </ShowIf>
        </HorizontalStack>
      </LinkHeaderCell>

      <PopoverTableConfig target={target?.current} />
    </>
  )
}
